

import React, { useEffect, useRef, useState } from "react";
import { checklist, upload_files, upload_ref_files } from "../api";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "react-loading-screen";
import { toast } from "react-toastify";

const ReferenceUpload = () => {
  const [inputFiles, setInputFiles] = useState("");
  const fileInputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
 
  const [selectedlist, setSelectedList] = useState([]);
  const [encrypted, setencrypted] = useState("");
  const [loading, setLoading] = useState(false);

  // New states for tracking processing and download availability
  const [processStatus, setProcessStatus] = useState("idle"); // 'idle' | 'processing' | 'completed' | 'error'
  const [processedBase64, setProcessedBase64] = useState("");

  const navigate = useNavigate();

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const files = e.dataTransfer.files;
    handleFiles(files);
  };

  const handleFiles = (files) => {
    if (files && files.length > 0) {
      // Reset process states for a new file selection
      setProcessStatus("idle");
      setProcessedBase64("");
      setUploadPercentage(0);
      

      const reader = new FileReader();
      reader.readAsDataURL(files[0]);

      reader.onloadend = () => {
        setencrypted(reader.result);
      };

      setInputFiles(files);
      startUploadSimulation();
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const startUploadSimulation = () => {
    setIsUploading(true);
    setUploadPercentage(0);

    const interval = setInterval(() => {
      setUploadPercentage((prevPercentage) => {
        if (prevPercentage >= 100) {
          clearInterval(interval);
          setIsUploading(false);
          return 100;
        }
        return prevPercentage + 10;
      });
    }, 100);
  };

  // Helper function to handle downloading base64 responses as a file
  const handleDownloadClick = (Base64) => {
    if (!Base64 || !inputFiles) return;

    const pureBase64 = Base64.split(",")[1] || Base64;
    const byteCharacters = atob(pureBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    
    const blob = new Blob([byteArray], { 
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = inputFiles[0].name.replace(/(\.doc|\.docx|\.tex)$/i, "") + "_processed.docx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };

  const handleSubmit = async () => {
    if (!inputFiles || inputFiles.length === 0) {
      toast.info("Please select a file to proceed");
      return;
    }

    // setLoading(true);
    setProcessStatus("processing");

    try {
      // Call backend API
      const result = await upload_ref_files(encrypted, inputFiles[0].name);


      if (result&&result.data) {
        const base64Response=result.data.content
        setProcessedBase64(base64Response);
        setProcessStatus("completed");
        toast.success("File processed successfully! You can now download it.");
        handleDownloadClick(base64Response)
      } else {
        setProcessStatus("error");
        const errorMessage = result.error||result.error.message||"Something went wrong on the server.";
        toast.error(errorMessage);
      }
    } catch (error) {
      setProcessStatus("error");
      toast.error(error.message || "Failed to communicate with backend server.");
    } finally {
      setLoading(false);
    }
  };
  
  const resetForm = () => {
    if(processStatus!=="processing"){
    setInputFiles("");
    setencrypted("");
    setProcessStatus("idle");
    setProcessedBase64("");
    if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
 
}
  };

  return (
    <div className="w-full p-10 flex flex-col">
      <LoadingScreen
        loading={loading}
        bgColor="#f1f1f1"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        text="Processing file, please wait..."
      >
        <h1 className="text-left text-154A79 font-semibold text-24">Reference Structuring</h1>
        <div className="w-full flex justify-center mt-8">
          <div className="w-full h-fit border-[1px] border-C4C6CC py-[42px] px-10 rounded-[24px]">
            <div
              className={`w-full border-[1px] border-dashed border-C4C6CC px-[8.681vw] py-[50px] flex flex-col items-center justify-center rounded-[12px] ${
                dragging ? "bg-222222" : "bg-F6F6F6"
              }`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div>
                <img
                  src={process.env.PUBLIC_URL + "/images/upload/file 1.png"}
                  alt="file_upload_img"
                />
              </div>
              {/* {dragging ? (
                <div className="flex">
                  <p className="text-white">Drop your files here</p>
                </div>
              ) : (
                <>
                  <div className="flex gap-1 mt-12 flex-wrap justify-center">
                    <p className="text-18 text-154A79 font-medium">
                      Drag and Drop file here or
                    </p>
                    <button
                      onClick={handleClick}
                      className="text-18 text-154A79 font-semibold underline underline-offset-2"
                    >
                      Choose file
                    </button>
                    <input
                      type="file"
                      name="project_name"
                      placeholder="Enter Project Name"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      multiple
                      onChange={(e) => handleFiles(e.target.files)}
                     accept=".doc,.docx,.docm,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 

                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-8C8A9B">
                      Supported formats: Word file
                    </p>
                  </div>
                </>
              )} */}
                <>
                  <div className="flex gap-1 mt-12 flex-wrap justify-center">
                    <p className="text-18 text-154A79 font-medium">
                      Drag and Drop file here or
                    </p>
                    <button
                      onClick={handleClick}
                      className="text-18 text-154A79 font-semibold underline underline-offset-2"
                    >
                      Choose file
                    </button>
                    <input
                      type="file"
                      name="project_name"
                      placeholder="Enter Project Name"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      multiple
                      onChange={(e) => handleFiles(e.target.files)}
                     accept=".doc,.docx,.docm,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 

                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-8C8A9B">
                      Supported formats: Word file
                    </p>
                  </div>
                </>
            </div>
            
            {inputFiles && inputFiles[0] && (
              <div className="p-6 border-[1px] border-C4C6CC mt-6 rounded-[12px] bg-F8F9FA">
                <div className="flex items-center justify-between">
                  <div className="flex items-center justify-between gap-4">
                    <span className="w-8 h-8">
                      <img
                        src={process.env.PUBLIC_URL + "/images/upload/word.png"}
                        className="w-full h-full object-cover"
                        alt="Doc"
                      />
                    </span>
                    <div className="flex flex-col items-start">
                      <p>{inputFiles[0].name}</p>
                      <p className="text-8C8A9B">
                        {inputFiles[0].size < 1000000
                          ? (inputFiles[0].size / 1024).toFixed(2) + " kb"
                          : (inputFiles[0].size / 1048576).toFixed(2) + " mb"}
                      </p>
                    </div>
                  </div>
                  <div>
                    <button onClick={resetForm} disabled={loading}>
                      <img
                        src={process.env.PUBLIC_URL + "/images/upload/cross.png"}
                        alt="close"
                      />
                    </button>
                  </div>
                </div>

                {/* Conditional UI Status Area below file name details */}
                <div className="w-full mt-5 pt-4 border-t border-E2E8F0">
                  {processStatus === "idle" && (
                    <div className="w-full flex items-center gap-2 justify-between">
                      <div className="h-2 rounded-[12px] bg-white relative z-0 w-[95%] flex items-center">
                        <div
                          className="absolute top-0 left-0 bg-FEB13F h-2 rounded-[12px]"
                          style={{ width: `${uploadPercentage}%` }}
                        ></div>
                      </div>
                      <p className="text-8C8A9B">{uploadPercentage}%</p>
                    </div>
                  )}

                  {processStatus === "processing" && (
                    <div className="flex items-center gap-3 text-154A79 font-medium animate-pulse">
                      <div className="w-4 h-4 border-2 border-t-transparent border-154A79 rounded-full animate-spin"></div>
                      <p>Processing... Please hold on.</p>
                    </div>
                  )}

                  {processStatus === "completed" && (
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-green-50 p-3 rounded-lg border border-green-200">
                      <p className="text-green-700 font-medium flex items-center gap-2">
                        ✓ Processed successfully!
                      </p>
                      <button
                        onClick={()=>handleDownloadClick(processedBase64)}
                        className="h-9 px-4 rounded-full bg-154A79 text-white font-medium text-14 shadow-sm hover:bg-opacity-90 transition-all flex items-center justify-center gap-1"
                      >
                        Download Word File
                      </button>
                    </div>
                  )}

                  {processStatus === "error" && (
                    <p className="text-red-500 font-medium">
                      ❌ Processing failed. Please clear and try again.
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
         
        <div className="w-full flex justify-end">
          <button
            onClick={handleSubmit}
            disabled={loading || isUploading || !inputFiles || processStatus !== "idle"}
            className={`min-w-[126px] px-4 h-[46px] my-[60px] rounded-[36px] text-white bg-[#E63946] disabled:bg-gray-400 disabled:cursor-not-allowed font-semibold transition-all ${
              loading || processStatus === "completed" ? "hidden bg-transparent cursor-not-allowed" : ""
            }`}
          >
            {loading|| processStatus=="processing" ? "Processing..." : "Submit"}
          </button>
        </div>
      </LoadingScreen>
    </div>
  );
};

export default ReferenceUpload;